import type { FaireProductEntity } from "../../entity_types/product";

export const p_zannf88uzd: FaireProductEntity = {
  token: "p_zannf88uzd",
  type: "product",
  name: "Mahjong Tile Puffy Heart Cord Keychain Bag Charm",
  brandToken: "b_drzk7thxry",
  brandName: "Designature New York",
  imageUrl:
    "https://cdn.faire.com/fastly/26d46f79278b9be845ca716d089b3032f967168d8ae09024826183c121eb2f39.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/293c2a3ebea332bd83762a54188595f9e24eef375f8795c7f523f22ebafc2bc2.jpeg",
    "https://cdn.faire.com/fastly/638fe2beb95d62c8a65ac98ad21652e1f925781df2d46e7be3cbb22f0e44f768.jpeg",
    "https://cdn.faire.com/fastly/13981eada9b958a1ca93d5cad70743aaa2bc791626129fb63f51f386e23d5861.jpeg",
    "https://cdn.faire.com/fastly/a1f528a55bd1b893a00871bce88396f1347ccc1ec229c8a1b5a73a84a3a47707.jpeg",
    "https://cdn.faire.com/fastly/053a3977b2ce4eb71e5643cd9e7ac70cef0b28b9b7d439396e32af39961cc95f.jpeg",
    "https://cdn.faire.com/fastly/a5adf6003e3819695a9a2e4ea6beb7b90f6034fa8f78d570c62964cfe0a1c27f.jpeg",
    "https://cdn.faire.com/fastly/3fc936f6a6c8468831f427d7298181edd03f727334dd3b65034fe85d17678601.jpeg",
    "https://cdn.faire.com/fastly/5b632b9bed6f2d26f2e69bdaf9f44bb98919f5b318504c26cb4ce17a0c845bce.jpeg",
    "https://cdn.faire.com/fastly/a7ef0f880358e4639bf2763fa22a5033a3cd45e710c9bfb97c3c2f9d43a39926.jpeg",
  ],
  priceDollars: 11,
  description:
    "Designed with mixed mahjong tile charms, this keychain offers a unique and eye catching look. The patterned paracord cord adds color and durability, paired with a metal puffy heart accent for extra charm. A fun everyday piece with strong gifting appeal.\n\n*Length: 7 Inch\n*Material: Resin, Cord, Zinc, Brass, Steel\n*Made in China\n\n#Mahjong #Tile #Mahjongtile #Flowers #Dragons #Jokers #Seasons #Blanks #Winds #Dots #Bamboo #Symbols #Dice #Suits #Rope #Cord #Weave #Paracord #Game #Trending #jewelrywholesale #Keychain #Bagcharm #Keyring",
  tags: [],
  msrpDollars: 33,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:52:43.011Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
